const MAX_EXCERPT_LENGTH = 250;

type ExcerptAstType = {
  children?: ExcerptAstType[];
  type?: string;
  value?: string;
};

export default function excerptAstToText(
  excerptAst?: ExcerptAstType | null
): string {
  if (!excerptAst) {
    return "";
  }
  if (excerptAst.type === "text" && excerptAst.value) {
    return excerptAst.value;
  }
  if (excerptAst.children?.length) {
    let childrenStr = "";
    for (let i = 0; i < excerptAst.children.length; i++) {
      const child = excerptAst.children[i];
      const newStr = `${childrenStr} ${excerptAstToText(child)}`;
      if (newStr.length >= MAX_EXCERPT_LENGTH) {
        return `${newStr.slice(0, MAX_EXCERPT_LENGTH)}...`;
      }
      childrenStr = newStr;
    }
    return childrenStr;
  }

  return "";
}
